import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue'

const managerRoutes: RouteConfig = {
    path: '/merchant',
    component: Layout,
    meta: {
        title: 'merchantMgt',
        icon: 'table',
        redirect: '/merchant/merchantList',
        // alwaysShow: true 
    },
    children: [
        {
            path: 'merchantList',
            name: 'Merchant Manage',
            component: () => import('@/views/merchant/merchantList.vue'),
            meta: {
                // title: 'merchantList',
                title: 'merchantMgt',
                icon: 'list',
                activeMenu: '/merchant/merchantList'
            }
        }
    ]

}

export default managerRoutes